import React, { useState, useEffect } from 'react';
import { APPLICATION_CLOSE_DATE } from '../../constants/configLoader';
import { calculateTimeLeft, padNumber } from '../../utils/timeUtils';
import './CountDown.css';

const CountDown = ({ showTitle, isMobile, titleImage }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // 초기 계산
    setTimeLeft(calculateTimeLeft(APPLICATION_CLOSE_DATE));
    
    // 1초마다 업데이트
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(APPLICATION_CLOSE_DATE));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {showTitle ? (
        <div className="sec_title_in_count_down">
          <img 
            src={titleImage}
            alt="APPLICATION CLOSES IN"
            className="apply_title"
          />
        </div>
      ) : (
        <div className="countdown_title">
          <h2>Application Closes In</h2>
        </div>
      )}
      <div className="countdown_container">
        <div className="countdown_item">
          <span className="countdown_number">{padNumber(timeLeft.days)}</span>
          <span className="countdown_label">Days</span>
        </div>
        <div className="countdown_item">
          <span className="countdown_number">{padNumber(timeLeft.hours)}</span>
          <span className="countdown_label">Hours</span>
        </div>
        <div className="countdown_item">
          <span className="countdown_number">{padNumber(timeLeft.minutes)}</span>
          <span className="countdown_label">Minutes</span>
        </div>
        <div className="countdown_item">
          <span className="countdown_number">{padNumber(timeLeft.seconds)}</span>
          <span className="countdown_label">Seconds</span>
        </div>
      </div>
    </>
  );
};

export default CountDown; 